import { memo } from 'react';
import {
  LayoutRectangle,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import Animated, { runOnJS } from 'react-native-reanimated';
import { AnnotationTagOption } from '../functions/AnnotationTagOption';
import { TagInfo } from '../functions/TagInfo';
import { TagOptionMenuLayer } from './TagOptionMenuLayer';
import { TagInteractionContext, TagView } from './TagView';

export const AnnotationCanvas = memo(
  ({
    tags,
    scale,
    width,
    height,
    style,
    tagOptions,
    onTap,
    onTagReadyForInteraction,
    onTagPress,
    onSelectTagOption,
    onDeleteTag,
    onTagMoveBegin,
    onTagMoveEnd,
    onTagLayoutChange,
  }: {
    scale?: number;
    width: number;
    height: number;
    tags: TagInfo[];
    style?: StyleProp<ViewStyle>;
    /** result options a tag can be switched to; empty means not switchable */
    tagOptions?: AnnotationTagOption[];
    onTap: (x: number, y: number) => void;
    onTagReadyForInteraction?: (
      id: string,
      interaction: TagInteractionContext,
    ) => void;
    onTagPress?: (id: string) => void;
    onSelectTagOption?: (id: string, option: AnnotationTagOption) => void;
    onDeleteTag?: (id: string) => void;
    onTagMoveBegin?: (id: string, x: number, y: number) => void;
    onTagMoveEnd?: (id: string, x: number, y: number) => void;
    onTagLayoutChange?: (id: string, layout: LayoutRectangle) => void;
  }) => {
    const selectedTag = tags.find(x => x.selected);
    const tap = Gesture.Tap().onBegin(e => {
      runOnJS(onTap)(e.x, e.y);
    });
    return (
      <View
        css={`
          width: ${width}px;
          height: ${height}px;
          position: absolute;
        `}
        style={style}
      >
        {/* @ts-ignore */}
        <GestureDetector gesture={tap}>
          <Animated.View
            style={StyleSheet.absoluteFill}
            css={`
              width: ${width}px;
              height: ${height}px;
              position: absolute;
            `}
          />
        </GestureDetector>
        {tags.map(tag => (
          <TagView
            key={tag.id}
            scale={scale}
            tag={tag}
            canvasWidth={width}
            canvasHeight={height}
            onReady={onTagReadyForInteraction}
            onPress={onTagPress}
            onDelete={onDeleteTag}
            onMoveBegin={onTagMoveBegin}
            onMoveEnd={onTagMoveEnd}
            onLayout={onTagLayoutChange}
          />
        ))}
        {selectedTag && tagOptions?.length ? (
          <TagOptionMenuLayer
            key={selectedTag.id}
            tag={selectedTag}
            scale={scale}
            canvasWidth={width}
            canvasHeight={height}
            options={tagOptions}
            onSelect={onSelectTagOption}
          />
        ) : null}
      </View>
    );
  },
);
